module.exports = __webpack_public_path__ + "static/img/background.f832e488.svg";